import { Button, Typography } from "@suraasa/placebo-ui"

import PgCTLLogoSpinning from "../PgCTLLogoSpinning"
import { usePgCTLOfferLetter } from "../usePgCTLOfferLetter"

const Content = ({
  handleViewOfferLetter,
}: {
  handleViewOfferLetter: () => void
}) => {
  const { offerLetter } = usePgCTLOfferLetter()

  return (
    <div className="flex flex-col items-center sm:pt-4">
      <div className="size-[145px]">
        {offerLetter && (
          <PgCTLLogoSpinning
            slug={offerLetter.product.slug}
            className="mx-auto"
          />
        )}
      </div>
      <div className="mx-auto max-w-[492px] pb-1.5 text-center sm:p-3">
        <Typography variant="title1" className="mb-1 sm:!text-[32px]">
          You’ve received your PgCTL offer letter
        </Typography>
        <Typography className="mb-5 text-onSurface-500">
          Review your offer details and complete your enrolment to start your
          journey with Suraasa.
        </Typography>
        <Button
          color="black"
          onClick={handleViewOfferLetter}
          className="mx-auto flex w-full sm:w-fit"
          autoFocus
        >
          View Offer Letter
        </Button>
      </div>
    </div>
  )
}

export default Content
